import React, { useEffect, useState } from "react";
import { brandCraft } from "..";
import "../headerComponent/header.scss";
import Button from "../../assets/common/button/Button";
import { FaHome, FaBars, FaTimes } from "react-icons/fa";
import IntroForm from "../IntroForm/IntroForm";

const Header = () => {
  // const location = useLocation();
  const [scroll, setScroll] = useState(false);
  const [prevScrollpos, setPrevScrollpos] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  // useEffect(() => {
  //   // setIsNavOpen(false);
  //   window.addEventListener("scroll", () => {
  //     setScroll(window.scrollY > 0);
  //   });
  //   const handleScroll = () => {
  //     const currentScrollpos = window.pageYOffset;

  //     if (prevScrollpos > currentScrollpos) {
  //       document.getElementById("header").style.top = "0";
  //     } else if (prevScrollpos > 500) {
  //       document.getElementById("header").style.top = "-150px";
  //     }
  //     setPrevScrollpos(currentScrollpos);
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [prevScrollpos]);

  useEffect(() => {
    // Lock/unlock body scroll when mobile menu is open/closed
    if (menuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
    // Clean up on unmount
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [menuOpen]);

  return (
    <header
      id="header"
      className={scroll ? "header" : "header topClass"}
      style={{ top: "0px" }}
    >
      <nav id="navBar">
        <div className="container">
          <div className="row header-wrap" id="desktMenuBar">
            <div className="image-wrap col-md-3 col-6">
              <img src={brandCraft} alt="brand-Craft" className="img-fluid" />
            </div>

            <div className="nav-menu col-md-6 d-none d-md-block">
              <ul className="d-flex justify-content-center mb-0 list-unstyled">
                <li className="home-icon me-3">
                  <a href="#heading">
                    <FaHome />
                  </a>
                </li>
                <li className="me-3">
                  <a href="#about">About</a>
                </li>
                <li className="me-3">
                  <a href="#services">Our Service</a>
                </li>
                <li className="me-3">
                  <a href="#projects">Projects</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 col-6 d-flex justify-content-end">
              <Button onClick={() => setIsModalOpen(true)} text="LET'S TALK" />
            </div>
          </div>
          <IntroForm
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />

          <div id="mobileMenuBar">
            <div className="d-flex justify-content-between align-items-center pe-3">
              <img src={brandCraft} alt="brand-Craft" className="img-fluid" />
              <button
                className="hamburger d-md-none"
                onClick={toggleMenu}
                aria-label="Toggle menu"
              >
                {menuOpen ? <FaTimes /> : <FaBars />}
              </button>
            </div>

            <div className={`mobile-nav ${menuOpen ? "active" : ""}`}>
              {/* <img src={brandCraft} alt="brand-Craft" className="img-fluid" /> */}
              <ul className="list-unstyled">
                <li className="home-icon">
                  <a href="#heading" onClick={() => setMenuOpen(false)}>
                    <FaHome />
                  </a>
                </li>
                <li>
                  <a href="#about" className="d-flex align-items-center" onClick={() => setMenuOpen(false)}>
                    About
                    <span className="material-symbols-outlined ms-auto">
                      chevron_forward
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#services" className="d-flex align-items-center" onClick={() => setMenuOpen(false)}>
                    Our Service
                    <span className="material-symbols-outlined ms-auto">
                      chevron_forward
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#projects" className="d-flex align-items-center" onClick={() => setMenuOpen(false)}>
                    Projects
                    <span className="material-symbols-outlined ms-auto">
                      chevron_forward
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#contact" className="d-flex align-items-center" onClick={() => setMenuOpen(false)}>
                    Contact
                    <span className="material-symbols-outlined ms-auto">
                      chevron_forward
                    </span>
                  </a>
                </li>
              </ul>
              <Button onClick={() => setIsModalOpen(true)} text="LET'S TALK" />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
